<!-- <ion-row class="c-border-bottom ion-margin-start">
  <ion-col size="12" class="ion-no-padding">
    <ion-row class="ion-margin-end">
      <ion-label>
        <ng-container *ngIf="asyncLabel; else NoAsyncLabel">
          <ng-container *ngIf="asyncLabel | async as dynamicLabel; else NoAsyncLabel">
            <div [ngClass]="{'c-label-invalid': cFormControl.dirty && cFormControl.invalid}" [innerHtml]="dynamicLabel"></div>
          </ng-container>
        </ng-container>
      </ion-label>
    </ion-row>
    <ion-row class="ion-margin-end ion-justify-content-center">
      <ion-col class="ion-no-padding" size="auto">
        <div class="c-signature-pad-canvas-container" [ngStyle]="{'--canvasBackground': !disabledField && canvasBackground}">
          <canvas class="c-signature-pad-canvas" ngClass="{'c-signature-pad-canvas-invalid': cFormControl.dirty && cFormControl.invalid}" #canvas width="280" height="210" style="touch-action: none;"></canvas>
        </div>
        <ion-row class="ion-justify-content-center" *ngIf="cFormControl.valid && !disabledField">
          <ion-button (click)="onRAZClick()" color="medium">
            RAZ
          </ion-button>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<ng-template #NoAsyncLabel>
  <div [innerHtml]="field.label"></div>
</ng-template> -->
<ion-row class="c-border-bottom ion-margin-start">
  <ion-col size="12" class="ion-no-padding">
    <ion-row class="ion-margin-end">
      <ion-label>
        <ng-container *ngIf="asyncLabel; else NoAsyncLabel">
          <ng-container *ngIf="asyncLabel | async as dynamicLabel; else NoAsyncLabel">
            <div [ngClass]="{'c-label-invalid': cFormControl.dirty && cFormControl.invalid && !((field.readonly ?? 0) | readonlyByRule: etatId)}" [innerHtml]="dynamicLabel"></div>
          </ng-container>
        </ng-container>
      </ion-label>
    </ion-row>

    <ion-row class="ion-margin-end ion-justify-content-center">
      <ion-col class="ion-no-padding" size="auto">
        <div
          class="c-signature-pad-canvas-container"
          [ngStyle]="{
            '--canvasBackground': (!disabledField && !((field.readonly ?? 0) | readonlyByRule: etatId)) ? canvasBackground : null,
            'pointer-events': (disabledField || ((field.readonly ?? 0) | readonlyByRule: etatId)) ? 'none' : 'auto',
            'opacity': (disabledField || ((field.readonly ?? 0) | readonlyByRule: etatId)) ? 0.6 : 1
          }"
        >
          <canvas
            class="c-signature-pad-canvas"
            [ngClass]="{'c-signature-pad-canvas-invalid': cFormControl.dirty && cFormControl.invalid && !((field.readonly ?? 0) | readonlyByRule: etatId)}"
            #canvas
            width="280"
            height="210"
            style="touch-action: none;"
          ></canvas>
        </div>

        <!-- RAZ visible seulement si éditable -->
        <ion-row class="ion-justify-content-center"
                 *ngIf="cFormControl.valid && !disabledField && !((field.readonly ?? 0) | readonlyByRule: etatId)">
          <ion-button (click)="onRAZClick()" color="medium">
            RAZ
          </ion-button>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<ng-template #NoAsyncLabel>
  <div [innerHtml]="field.label"></div>
</ng-template>
